import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer
      style={{
        background: "#1a1a1a",
        color: "#ffffff",
        padding: "3rem 1rem 1.5rem",
        marginTop: "4rem",
        fontFamily: "inherit",
      }}
    >
      <div className="container">
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: "2.5rem",
            marginBottom: "2rem",
          }}
        >
          {/* Brand & Mission */}
          <div>
            <h3 style={{ color: "#e91e63", marginBottom: "1rem" }}>
              FloraCare
            </h3>
            <p style={{ fontSize: "0.9rem", color: "#ccc", lineHeight: "1.6" }}>
              Empowering women through smart AI health tracking and expert-led
              childcare solutions.
            </p>
          </div>

          {/* Useful Links */}
          <div>
            <h4
              style={{
                marginBottom: "1.2rem",
                borderBottom: "2px solid #e91e63",
                display: "inline-block",
              }}
            >
              Links
            </h4>
            <ul style={{ listStyle: "none", padding: 0, lineHeight: "2.2" }}>
              <li>
                <Link to="/" style={{ color: "#ccc", textDecoration: "none" }}>
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  style={{ color: "#ccc", textDecoration: "none" }}
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/tracker"
                  style={{ color: "#ccc", textDecoration: "none" }}
                >
                  GyneCare
                </Link>
              </li>
              <li>
                <Link
                  to="/babycare"
                  style={{ color: "#ccc", textDecoration: "none" }}
                >
                  BabyCare
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Presence */}
          <div>
            <h4
              style={{
                marginBottom: "1.2rem",
                borderBottom: "2px solid #e91e63",
                display: "inline-block",
              }}
            >
              Follow Us
            </h4>
            <div
              style={{
                display: "flex",
                gap: "15px",
                fontSize: "1.2rem",
                marginTop: "10px",
              }}
            >
              <i className="fab fa-instagram" style={{ cursor: "pointer" }}></i>
              <i className="fab fa-twitter" style={{ cursor: "pointer" }}></i>
              <i className="fab fa-linkedin" style={{ cursor: "pointer" }}></i>
            </div>
          </div>
        </div>

        <hr
          style={{ border: "0", borderTop: "1px solid #333", margin: "2rem 0" }}
        />

        <div
          style={{ textAlign: "center", fontSize: "0.85rem", color: "#888" }}
        >
          <p>
            © 2026 FloraCare. Developed by **Vedant**, **Krishna** & **Riya**.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
